/* eslint-disable max-len */
import { logoSpinnerBackground, logoSpinnerContainer } from '../style.css';

type LogoSpinnerProps = {
  size?: number;
};

const LogoSpinner = ({ size = 90 }: LogoSpinnerProps) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 200 200"
      color="#fff"
      className={logoSpinnerBackground}
    >
      <g
        strokeWidth="5"
        fillOpacity="0.5"
        fill="black"
      >
        <path
          stroke="url(#spinner-secondHalf)"
          d="M 4 100 A 96 96 0 0 1 196 100"
        />
        <path
          stroke="url(#spinner-firstHalf)"
          d="M 196 100 A 96 96 0 0 1 4 100"
        />
      </g>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 200 200"
      color="#fff"
      className={logoSpinnerContainer}
    >
      <g
        clipPath="url(#clip0_4962_432607)"
        transform="scale(3.1) translate(23,13)"
      >
        <path
          d="M-0.815796 31.917H15.9247V26.4591H5.00214V22.5765H14.8547V17.2961H5.00214V13.3026H15.9247V8H-0.815796V31.917Z"
          fill="white"
        />
        <path
          d="M22.2174 7.70688C24.3617 7.66195 26.0772 5.95449 26.1224 3.82018C26.0772 1.66339 24.2715 -0.0440662 22.1045 0.000866863C20.0053 0.0457999 18.3349 1.73079 18.2672 3.82018C18.3124 5.95449 20.073 7.68442 22.2174 7.70688Z"
          fill="#F72442"
        />
        <mask
          id="mask0_4962_432607"
          maskUnits="userSpaceOnUse"
          x="-1"
          y="8"
          width="17"
          height="24"
        >
          <path
            d="M-0.815796 31.917H15.9247V26.4591H5.00214V22.5765H14.8547V17.2961H5.00214V13.3026H15.9247V8H-0.815796V31.917Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_4962_432607)">
          <path
            opacity="0.2"
            d="M-5.00635 -10.1041C-5.00635 -10.1041 -2.64351 29.1659 60.8856 28.1897C124.415 27.2135 127.692 -29.7613 127.692 -29.7613L-5.00635 -10.1041Z"
            fill="url(#paint0_linear_4962_432607)"
          />
        </g>
      </g>

      <defs>
        <linearGradient id="spinner-secondHalf">
          <stop offset="0%" stopOpacity="0" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
        <linearGradient id="spinner-firstHalf">
          <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id="paint0_linear_4962_432607"
          x1="52.7627"
          y1="29.1036"
          x2="65.0243"
          y2="-40.7603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72442" />
          <stop offset="0.05" stopColor="#CE1E37" />
          <stop offset="0.13" stopColor="#981629" />
          <stop offset="0.21" stopColor="#690F1C" />
          <stop offset="0.29" stopColor="#430A12" />
          <stop offset="0.37" stopColor="#26060A" />
          <stop offset="0.45" stopColor="#110204" />
          <stop offset="0.52" stopColor="#040101" />
          <stop offset="0.59" />
        </linearGradient>
        <clipPath id="clip0_4962_432607">
          <rect width="26.1224" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);

export default LogoSpinner;
